/**
 * The one card shape on the profile.
 *
 * Before this existed there were two header conventions --
 * `.profile-info-card__head` (14 instances) and a bare
 * `.profile-section__title` (4) -- which meant two different type scales and
 * two different rules about where a source tag goes.
 *
 * `tag` is the small uppercase marker in the header ("Synced from Odoo",
 * "Managed by HR"). It is deliberately OPTIONAL and used sparingly: a tag that
 * every card carries tells the reader nothing.
 */
export default function ProfileCard({ title, tag, span = false, children, ...rest }) {
  return (
    <section className={`profile-info-card${span ? ' profile-info-card--span' : ''}`} {...rest}>
      {title && (
        <header className="profile-info-card__head">
          <h2 className="profile-info-card__title">{title}</h2>
          {tag && <span className="profile-source-tag">{tag}</span>}
        </header>
      )}
      {children}
    </section>
  );
}
